// 기본 환율: 100엔당 1000원
const DEFAULT_EXCHANGE_RATE = 1000;
const STORAGE_KEY = 'exchangeRate';

/**
 * 로컬 스토리지에서 환율 가져오기
 * @returns 저장된 환율 또는 기본값 (1000원)
 */
export const getExchangeRate = (): number => {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored) {
    try {
      return JSON.parse(stored);
    } catch {
      return DEFAULT_EXCHANGE_RATE;
    }
  }
  return DEFAULT_EXCHANGE_RATE;
};

/**
 * 로컬 스토리지에 환율 저장
 * @param rate 저장할 환율
 */
export const setExchangeRate = (rate: number): void => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(rate));
};
